import { useAttachments } from '..'
import { useTranslation } from 'react-i18next'
import { useState, ReactNode } from 'react'
import { UploadIcon } from '@heroicons/react/outline'
import { useTw } from '../../../../../../../../utils/Styles'

type Props = { children: ReactNode }

export function AttachmentDrop({ children }: Props) {
  const tw = useTw()
  const [t] = useTranslation('common')
  const [isDrag, setDrag] = useState(false)
  const { addAttachment } = useAttachments()

  return (
    <div
      className={tw`relative`}
      onDragLeave={() => isDrag && setDrag(false)}
      onDragOver={(e) => {
        e.preventDefault()
        !isDrag && setDrag(true)
      }}
      onDrop={(e) => {
        e.preventDefault()
        setDrag(false)
        if (e.dataTransfer.items) {
          const i = Array.from(e.dataTransfer.items).filter(
            (_) => _.kind === 'file'
          )

          if (i[0]) addAttachment(i[0].getAsFile())
        } else {
          const i = e.dataTransfer.files
          if (i[0]) addAttachment(i[0])
        }
      }}
    >
      {isDrag ? (
        <div
          className={tw`bg-white opacity-90 absolute z-10 top-0 left-0 right-0 bottom-0 pointer-events-none`}
        />
      ) : null}
      {isDrag ? (
        <div
          className={tw`flex m-3 text-neutral-350 border rounded border-dashed border-neutral-300 items-center justify-center absolute z-20 top-0 left-0 right-0 bottom-0 pointer-events-none`}
        >
          <UploadIcon className={tw`h-6 w-6 text-neutral-350 mr-4`} />
          {t('conversation.upload.drop')}
        </div>
      ) : null}
      {children}
    </div>
  )
}
